import { Grupo } from "./Grupo";

// models/produtos/SubGrupo.js
export class SubGrupo {
    constructor(id = 0, descricao = '', grupoId = 0, grupo = new Grupo(),) {
        this.id = id;
        this.descricao = descricao;
        this.grupoId = grupoId;
        this.grupo = grupo;
    }
}